import { render, staticRenderFns } from "./PlayerCard.vue?vue&type=template&id=555ef3ac"
import script from "./PlayerCard.vue?vue&type=script&lang=js"
export * from "./PlayerCard.vue?vue&type=script&lang=js"
import style0 from "./PlayerCard.vue?vue&type=style&index=0&id=555ef3ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports